export const skills = [
  // { value: "Web Development", label: "Web Development" },
  { value: "FrontEnd Developer", label: "FrontEnd Developer" },
  { value: "BackEnd Developer", label: "BackEnd Developer" },
  { value: "Full Stack Developer", label: "Full Stack Developer" },
  { value: "JavaScript", label: "JavaScript" },
  { value: "Python", label: "Python" },
  { value: "ReactJS", label: "ReactJS" },
  { value: "NodeJS", label: "NodeJS" },
  { value: "Django", label: "Django" },
  { value: "SQL", label: "SQL" },
  { value: "WordPress Developer", label: "WordPress Developer" },

  // { value: "App Development", label: "App Development" },
  { value: "Flutter", label: "Flutter" },
  { value: "React Native", label: "React Native" },

  { value: "Graphics Designing", label: "Graphics Designing" },
  { value: "Adobe Photoshop", label: "Adobe Photoshop" },

  // { value: "Documentation", label: "Documentation" },
  { value: "MS Word", label: "MS Word" },
  { value: "MS Excel", label: "MS Excel" },
  { value: "MS PowerPoint", label: "MS PowerPoint" },
];
